import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import './AnotherCity.scss';

type AnotherCityProps = {
  handleSubmit: (city: string) => void;
  originalCity: string;
};

const AnotherCity = ({ handleSubmit, originalCity }: AnotherCityProps) => {
  const [city, setCity] = useState('');
  const [isTouched, setIsTouched] = useState(false);

  const isInputEmpty = city.trim() === '';

  const isSubmitDisabled =
    city.trim().toLowerCase() === originalCity.toLowerCase() || isInputEmpty;

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isSubmitDisabled) {
      handleSubmit(city);
      setCity('');
    }
    setIsTouched(false);
  };

  const handleInputTouch = () => {
    setIsTouched(true);
  };

  // styles for input box
  const inputStyles = {
    color: '#333333',
    '&::placeholder': {
      color: '#333333',
    },
    paddingTop: '12px',
  };

  return (
    <div className="another-city-container">
      <Typography variant="h5" color="primary" className="heading">
        Looking for another city?
      </Typography>
      <form className="form" onSubmit={handleFormSubmit}>
        <div className="form-row">
          <TextField
            className="another-city-input"
            error={isSubmitDisabled && isTouched && !isInputEmpty}
            helperText={
              isTouched &&
              !isInputEmpty &&
              isSubmitDisabled &&
              'Please enter a different city'
            }
            inputProps={{ style: inputStyles }}
            name="city"
            onChange={(e) => setCity(e.target.value)}
            onFocus={handleInputTouch}
            placeholder="Enter your city name"
            type="text"
            value={city}
            variant="filled"
          />
        </div>
        <Button
          className="submit-button"
          disabled={isSubmitDisabled}
          type="submit"
          variant="contained"
        >
          Submit
        </Button>
      </form>
    </div>
  );
};

export default AnotherCity;
